(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    (() => {
        let excludingVat = false;
        let selected = false;
        let scheduled = false;

        function syncVatSelection() {
            scheduled = false;
            if (!selected) return;
            document.querySelectorAll('[data-vat-native]').forEach((input) => {
                if (input.checked !== excludingVat) input.checked = excludingVat;
            });
        }

        document.addEventListener('change', (event) => {
            if (!(event.target instanceof HTMLInputElement) || !event.target.matches('[data-vat-native]')) return;
            excludingVat = event.target.checked;
            selected = true;
            syncVatSelection();
        }, true);

        const observer = new MutationObserver(() => {
            if (scheduled) return;
            scheduled = true;
            requestAnimationFrame(syncVatSelection);
        });
        observer.observe(document.getElementById('MainContent') || document.body, {childList: true, subtree: true});
    })();
  } catch(e) { console.error(e); }
})();

})();
